import { useAuth0 } from "@auth0/auth0-react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography
} from "@mui/material";

const FEATURE_ITEMS = [
  {
    title: "Compliance tools",
    description:
      "Run compliance lookup and diffs, and use the deadlines engine to reason over annual reports, tax accounts, licensing, and related filing rules."
  },
  {
    title: "Assessments",
    description:
      "Review the assessment log, open saved assessments, and trace how compliance conclusions were reached over time."
  },
  {
    title: "Reference data",
    description:
      "Maintain entity compliance profiles and state-level rules for registrations, taxes, licenses, employment, and structured deadline logic in one place."
  },
  {
    title: "API & integrations",
    description:
      "Manage API keys, inspect usage on the API Dashboard, and browse interactive API docs for programmatic access to CRED."
  },
  {
    title: "Operations",
    description:
      "Validate data quality, inspect the audit log for administrative actions, and follow product changes via the changelog."
  }
] as const;

export default function Dashboard() {
  const { user } = useAuth0();

  return (
    <Box>
      <Paper
        variant="outlined"
        sx={{
          p: { xs: 2.5, sm: 3 },
          bgcolor: (theme) =>
            theme.palette.mode === "light"
              ? "rgba(26, 51, 83, 0.04)"
              : undefined
        }}
      >
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Welcome to Compliance Rules Engine Database
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          paragraph
          sx={{ maxWidth: 720 }}
        >
          CRED - the{" "}
          <Box component="span" sx={{ fontWeight: 600, color: "text.primary" }}>
            Compliance Rules Engine Database
          </Box>
          —is your operational hub for profit-company compliance knowledge. This
          console lets staff explore rules, manage authoritative reference data,
          run assessments, and monitor how the CRED API is used.
        </Typography>
        {user?.email && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Signed in as {user.email}
          </Typography>
        )}
        <Typography
          variant="subtitle1"
          fontWeight={600}
          gutterBottom
          sx={{ mt: 2 }}
        >
          What you can do here
        </Typography>
        <List dense disablePadding sx={{ py: 0 }}>
          {FEATURE_ITEMS.map(({ title, description }) => (
            <ListItem
              key={title}
              disablePadding
              sx={{ alignItems: "flex-start", py: 1 }}
            >
              <ListItemText
                primary={title}
                secondary={description}
                primaryTypographyProps={{
                  variant: "subtitle2",
                  fontWeight: 600
                }}
                secondaryTypographyProps={{
                  variant: "body2",
                  color: "text.secondary"
                }}
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Box>
  );
}

